export const RECOGNITION_CONFIG = {
  minPoints: 5,
  confidenceThreshold: 0.5,
  simplifyTolerance: 5,
  lineAspectRatioThreshold: 4,
  lineStraightnessThreshold: 0.5,
  lineStraightnessScale: 0.3,
  lineFallbackConfidence: 0.3,
  lineMaxConfidence: 0.95,
  nonClosedLineConfidenceThreshold: 0.4,
  closedShapeDiagonalFactor: 0.35,
  closedShapeTailFactor: 0.2,
  closedShapeTailDistanceFactor: 0.25,
  cornerAngleThreshold: 50,
  firstCornerDistance: 30,
  cornerMergeDistanceFactor: 0.15,
  rightAngleTolerance: 45,
  rectangleCornerBaseConfidence: 0.4,
  rectangleCornerScale: 0.5,
  rectangleDefaultConfidence: 0.8,
  rectangleMaxConfidence: 0.9,
  rectangleEdgeScoreThreshold: 0.6,
  rectangleEdgeScoreScale: 0.8,
  rectangleConfidenceThreshold: 0.3,
  rectangleFallbackConfidence: 0.2,
  rectangleClosedFallbackConfidence: 0.4,
  rectanglePadding: 10,
  ellipseMinRadius: 5,
  ellipseDeviationWeight: 1.5,
  ellipseQuadrantBonus: 0.1,
  ellipseConfidenceThreshold: 0.3,
  ellipseMaxConfidence: 0.95,
  ellipsePadding: 10,
  edgeThresholdFactor: 0.15,
};
